import { Address, Location } from '../../redux/types';

export function buildAddressMap(locations: Location[]): Record<string, Address> {
    return Object.fromEntries(
        locations
            .filter((location) => location.status === 'Active')
            .filter((location) => location.shippingAddress?.status === 'Active')
            .map((location) => [location.code, location.shippingAddress as Address])
    );
}
